// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__4qH3Z","requiredAsterisk":"Info_requiredAsterisk__24zmY"};